import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RankPage from "../pages/rank/page";
import RecommendPage from "../pages/recommend/page";
import BooklistPage from "../pages/booklist/page";
import DiscussionPage from "../pages/discussion/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rank",
    element: <RankPage />,
  },
  {
    path: "/recommend",
    element: <RecommendPage />,
  },
  {
    path: "/booklist",
    element: <BooklistPage />,
  },
  {
    path: "/discussion",
    element: <DiscussionPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;